import {ActionButtonWidget} from './ActionButton'
import {AddressWidget} from './Address'
import {CostDetailWidget} from './CostDetail'
import {CounterWidget} from './Counter'
import {DividerWidget} from './Divider'
import {DropdownListWidget} from './DropdownList'
import {FormWidget} from './Form/FormWidget@mobile'
import {HeaderWidget} from './Header'
import {IconWidget} from './Icon'
import {IconButtonWidget} from './IconButton'
import {IconSpotWidget} from './IconSpot'
import {ImageWidget} from './Image'
import {PhoneInputWidget} from './Inputs/PhoneInput'
import {TextInputWidget} from './Inputs/TextInput'
import {NavWidget} from './Nav'
import {PaymentMethodMobile as PaymentMethod} from './payment-method'
import {RadioWidget} from './Radio'
import {SegmentWidget} from './Segment'
import {SlotWidget} from './Slot'
import {SwitchWidget} from './Switch'
import {TagLineWidget} from './TagLine'
import {TextWidget} from './Text'
import {type WidgetConfig, WidgetType} from './types'
import {VerticalsWidget} from './Verticals/index@mobile'

export const mapTypeToWidget = {
  [WidgetType.ACTION_BUTTON]: ActionButtonWidget,
  [WidgetType.WEB_ACTION_BUTTON]: ActionButtonWidget,
  [WidgetType.ADDRESS]: AddressWidget,
  [WidgetType.DIVIDER]: DividerWidget,
  [WidgetType.FORM]: FormWidget,
  [WidgetType.HEADER]: HeaderWidget,
  [WidgetType.ICON]: IconWidget,
  [WidgetType.ICON_BUTTON]: IconButtonWidget,
  [WidgetType.ICON_SPOT]: IconSpotWidget,
  [WidgetType.NAV]: NavWidget,
  [WidgetType.PAYMENT_METHOD]: PaymentMethod,
  [WidgetType.IMAGE]: ImageWidget,
  [WidgetType.RADIO]: RadioWidget,
  [WidgetType.SEGMENT]: SegmentWidget,
  [WidgetType.SLOT]: SlotWidget,
  [WidgetType.SWITCH]: SwitchWidget,
  [WidgetType.TAG_LINE]: TagLineWidget,
  [WidgetType.TEXT]: TextWidget,
  [WidgetType.DROPDOWN_LIST]: DropdownListWidget,
  [WidgetType.TEXT_INPUT]: TextInputWidget,
  [WidgetType.PHONE_INPUT]: PhoneInputWidget,
  [WidgetType.COST_DETAIL]: CostDetailWidget,
  [WidgetType.COUNTER]: CounterWidget,
  [WidgetType.VERTICALS]: VerticalsWidget,
}

export const renderWidget = <T extends WidgetConfig>(
  externalProps: T,
  index?: number | string,
): React.ReactElement | null => {
  const Component = mapTypeToWidget[externalProps.type]

  if (Component) {
    const props = 'key' in externalProps ? {...externalProps, name: externalProps.key} : externalProps
    const key = 'widget_id' in props ? `${props.widget_id}_${index}` : index

    return (
      <Component
        key={key}
        // @ts-expect-error чего-то не хватило до полной типизации 🤷‍♂️
        config={props}
      />
    )
  }

  // TODO: Выкидывать ошибку после завершения разработки виджетов
  // throw new Error(`Виджет ${props.type} не найден`)
  return null
}
